goog.provide('el8.appchart.mgr.taskbar');
goog.provide('el8.appchart.mgr.onHold');
goog.provide('el8.appchart.mgr.overlay');
goog.provide('el8.appchart.mgr.taskbar.render');

goog.require('el8.appchart.mgr.orderForm');
goog.require('el8.template.appchart.mgr.taskbar');

goog.require('el8.service.intervals');
goog.require('el8.util.consts');


// -----------------------------
// * taskbarMgr.js *
//
// This file manages the taskbar, in particular
// minimizing and maximizing and resizing.
// Ensures onHoldMgr and overlayMgr act in coordinated fashion
//
// TODO Decided to lump all of onHoldMgr and overlayMgr here, because their
// current implementation generates a lot of circular dependencies, which we
// should sort out later - KF (2011.03.04)
// -----------------------------
el8.appchart.mgr.taskbar = (function() {

    var minimizeState = true;

    function init() {

        el8.appchart.mgr.onHold.init();
        el8.appchart.mgr.overlay.init();

        // ---------------------------
        // Prepare for resizing
        // ---------------------------
        /**
         * TODO We want to deprecate $(window).resize calls
         * in favor of using the el8_resizeApp trigger, but this
         * module is so old, we will plan on rewriting rather than
         * migrating to the new el8_resizeApp triggers
         */
        $(window).resize( function(e) {
            e.preventDefault();
            el8.appchart.mgr.taskbar.render.resize();
        });

    }

    return {
        init: init
    };

})();

// -----------------------------
// * ui.taskbar.js *
//
// This file contains the code that determines how minimized
// items in the taskbar are rendered
// -----------------------------

el8.appchart.mgr.taskbar.render = (function() {

    var standardItemWidth = 180;
    var taskbarItemClass = 'taskbarContainerMin';
    var MAX_TEXT_LENGTH = 25;

    function truncateText( text ) {
        if( text.length > MAX_TEXT_LENGTH ) {
            return text.substring(0, MAX_TEXT_LENGTH) + '...';
        } else {
            return text;
        }
    }

    function taskbarListDialog( spec ) {

        var container = spec.container;

        container.jqm({
            modal : false,
            overlay : 0
        });

        var width = 1;  // initialize at minimal width
        container.outerWidth( width );

        function position() {
            container.css( 'bottom', 25 );
        }
        position();

        /**
         * TODO We want to deprecate $(window).resize calls
         * in favor of using the el8_resizeApp trigger, but this
         * module is so old, we will plan on rewriting rather than
         * migrating to the new el8_resizeApp triggers
         */
        $(window).on('resize', function(e) {
            position();
        });

        return container;
    }

    function renderTaskbarItem( spec ) {

        var divId = spec.divId;
        var text = spec.text;
        var textClass = spec.textClass;

        var result = $(el8.template.appchart.mgr.taskbar.renderItem({
            taskbarClass: taskbarItemClass,
            id: divId,
            text: truncateText(text)
        }));
        result.css('width', standardItemWidth);

        return result;
    }

    function resize() {

        // TODO: This is not exactly accurate
        var maxWidth = $(window).width() - el8.util.consts.REF_PANEL_WIDTH;
        var newWidth = 0;

        var numItems = $('.' + taskbarItemClass).length;

        if( maxWidth / numItems < standardItemWidth ) {
            newWidth = Math.floor( maxWidth / numItems );
        } else {
            newWidth = standardItemWidth;
        }

        // All on hold and minimized items share this class
        $('.' + taskbarItemClass).outerWidth( newWidth );

        // TODO: Deal with text overflowing when width gets thin...
        // Need mapping from textlength to widths...
        //$('.' + taskbarItemClass).each( function() {
        //    var text = $(this).find('.taskbarText').html();
        //    $(this).find('.taskbarText').text( truncateText( text ) );
        //});

        el8.appchart.mgr.onHold.resize();
        el8.appchart.mgr.overlay.resize();
    }

    return {
        listDialog: taskbarListDialog,
        renderItem: renderTaskbarItem,
        resize: resize,
        itemWidth: standardItemWidth
    };
})();

// ------------------------------
// * overlayMgr.js *
//
// Controls display of overlays - report feed & medication feed -
// in the taskbar
// ------------------------------
el8.appchart.mgr.overlay = (function() {

    var container = null;
    var listContainer = null;

    var minDivIds = []; // array of div id's
    var minDivIdMap = {}; // map divId to array index in minDivIds
    var minId = 0;  // assign unique ID to each

    var idPrefix = 'min_';

    function init() {

        container = el8.appchart.mgr.taskbar.render.listDialog({
            container: $('#taskbar-minimize-ui')
        });

        resize();
        container.jqmHide();
    }

    function resize() {

        var newWidth = 0;
        container.children().each( function() {
            newWidth += $(this).outerWidth();
        });
        container.outerWidth( newWidth + 1 ); // 5 for just a bit more room

        // Comes after (to left of) onHold items
        container.css( 'left', el8.appchart.mgr.onHold.getLeftOffset() - container.width() );

    }

    function addItem( spec ) {

        minId++;

        var text = spec.text;
        var maximizeFn = spec.maximizeFn || function() {};
        var divId = idPrefix + minId;

        var result = el8.appchart.mgr.taskbar.render.renderItem({
            divId: divId,
            text: text,
            textClass: 'taskbarMinimizeHeader'
        });

        result.unbind('click').on('click', function(event) {
            event.preventDefault();
            maximizeFn();
            result.unbind('click');
        });

        container.append(result);
        container.jqmShow();

        minDivIds.push( divId );
        minDivIdMap[ divId ] = minDivIds.length - 1;

        el8.appchart.mgr.taskbar.render.resize();
        return divId;

    }

    function removeItem( divId ) {
        container.find('#' + divId).remove();
        minDivIds.splice( minDivIdMap[ divId ], 1 );
        delete minDivIdMap[ divId ];
        $.el8_setTimeout( function() {
            el8.appchart.mgr.taskbar.render.resize();
        }, 1000 );
    }

    function getLeftOffset() {
        return container.offset().left;
    }

    return {
        init : init,
        addItem : addItem,
        removeItem : removeItem,
        resize : resize,
        getLeftOffset : getLeftOffset
    };

})();

// ------------------------------
// * onHoldMgr.js *
//
// Controls display of "on hold" items in the taskbar
// ------------------------------
el8.appchart.mgr.onHold = (function() {

    var container;
    var listContainer;

    var onHoldDivIds = []; // array of div id's
    var onHoldDivIdMap = {}; // map divId to array index in onHoldDivIds

    // Map item model class to divId.  Right now we only allow one on hold
    // item per model class, so this is fine. In future may need item feedItemId
    // (reason we avoid now is that it requires item to be saved before minimized)
    var onHoldItemMap = {}; // map item's modelClass to divId
    var maximizeFnMap = {}; // map item's modelClass maximizeFn

    var onHoldId = 0; // assign unique ID to each on hold item
    var idPrefix = 'onhold_';

    function init() {

        container = el8.appchart.mgr.taskbar.render.listDialog({
            container: $('#taskbar-on-hold-ui')
        });

        resize();
        container.jqmHide();
    }

    function resize() {

        var newWidth = 0;
        container.children().each( function() {
            newWidth += $(this).outerWidth();
        });
        container.outerWidth( newWidth + 1 ); // 5 for just a bit more room

        // Rightmost taskbar items
        container.css( 'right', 20 );
    }

    function addItem( item, showFn ) {

        onHoldId++;

        var text = item.getDescription() + ' In Progress';
        var divId = idPrefix + onHoldId;

        var modelClass = item.getModelClass();
        if (item.is('MedOrder')) {
            modelClass = modelClass + '-' + item.getPrintType();
            text = item.getPrintType().capitalize() + ' Rx In Progress';
        }

        var result = el8.appchart.mgr.taskbar.render.renderItem({
            divId: divId,
            text: text,
            textClass: 'taskbarOnHoldHeader'
        });

        container.append(result);
        container.jqmShow();

        onHoldDivIds.push( divId );
        onHoldDivIdMap[ divId ] = onHoldDivIds.length - 1;
        onHoldItemMap[ modelClass ] = divId;

        if( showFn ) {
            var maximizeFn = function() {
                showFn();
                removeItem( item );
                result.unbind('click');
            };
            result.unbind('click').on('click', function(event) {
                maximizeFn();
            });
            maximizeFnMap[ modelClass ] = maximizeFn;
        }

        el8.appchart.mgr.taskbar.render.resize();
        return result;
    }

    function removeItem( item ) {

        var modelClass = item.getModelClass();
        if (item.is('MedOrder')) {
            modelClass = modelClass + '-' + item.getPrintType();
        }

        var divId = onHoldItemMap[ modelClass ];
        // If there is an on hold item of this type...
        if (container.find('#'+divId).length) {
            container.find('#'+divId).remove();
            onHoldDivIds.splice( onHoldDivIdMap[ divId ], 1 );
            delete onHoldDivIdMap[ divId ];
            delete onHoldItemMap[ modelClass ];
            delete maximizeFnMap[ modelClass ];
            $.el8_setTimeout( function() {
                el8.appchart.mgr.taskbar.render.resize();
            }, 1000 );
        }
    }

    function getLeftOffset() {
        return container.offset().left;
    }

    return {
        init: init,
        addItem: addItem,
        removeItem: removeItem,
        resize: resize,
        getLeftOffset: getLeftOffset
    };

})();
